import { apiSlice } from '../apiSlice';

const toList = (response) => response?.data || [];

export const settingApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRegioni: builder.query({
      query: () => ({
        url: '/regioni',
        method: 'GET',
      }),
      transformResponse: toList,
      providesTags: ['Region'],
    }),
    addRegion: builder.mutation({
      query: (body) => ({
        url: '/regioni',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Region'],
    }),
    updateRegion: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/regioni/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Region'],
    }),
    deleteRegion: builder.mutation({
      query: (id) => ({
        url: `/regioni/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Region', 'Province', 'City', 'Clinic'],
    }),

    getProvinces: builder.query({
      query: (regionId) => ({
        url: '/province',
        method: 'GET',
        params: { regionId },
      }),
      transformResponse: toList,
      providesTags: (result, error, regionId) => [
        { type: 'Province', id: regionId },
        'Province',
      ],
    }),
    addProvince: builder.mutation({
      query: (body) => ({
        url: '/province',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Province'],
    }),
    updateProvince: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/province/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Province'],
    }),
    deleteProvince: builder.mutation({
      query: (id) => ({
        url: `/province/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Province', 'City', 'Clinic'],
    }),

    getCitta: builder.query({
      query: (provinceId) => ({
        url: '/citta',
        method: 'GET',
        params: { provinceId },
      }),
      transformResponse: toList,
      providesTags: (result, error, provinceId) => [
        { type: 'City', id: provinceId },
        'City',
      ],
    }),
    addCitta: builder.mutation({
      query: (body) => ({
        url: '/citta',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['City'],
    }),
    updateCitta: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/citta/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['City'],
    }),
    deleteCitta: builder.mutation({
      query: (id) => ({
        url: `/citta/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['City', 'Clinic'],
    }),

    getClinic: builder.query({
      query: (params = {}) => ({
        url: '/clinics',
        method: 'GET',
        params,
      }),
      transformResponse: toList,
      providesTags: ['Clinic'],
    }),
    addClinic: builder.mutation({
      query: (body) => ({
        url: '/clinics',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Clinic'],
    }),
    updateClinic: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/clinics/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Clinic'],
    }),
    deleteClinic: builder.mutation({
      query: (id) => ({
        url: `/clinics/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Clinic'],
    }),
    
    getSystemSettings: builder.query({
      query: () => ({
        url: '/settings',
        method: 'GET',
      }),
      providesTags: ['SystemSettings'],
    }),
    updateSystemSettings: builder.mutation({
      query: (body) => ({
        url: '/settings',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['SystemSettings'],
    }),
  }),
});

export const {
  useGetRegioniQuery,
  useAddRegionMutation,
  useUpdateRegionMutation,
  useDeleteRegionMutation,
  useGetProvincesQuery,
  useAddProvinceMutation,
  useUpdateProvinceMutation,
  useDeleteProvinceMutation,
  useGetCittaQuery,
  useAddCittaMutation,
  useUpdateCittaMutation,
  useDeleteCittaMutation,
  useGetClinicQuery,
  useAddClinicMutation,
  useUpdateClinicMutation,
  useDeleteClinicMutation,
  useGetSystemSettingsQuery,
  useUpdateSystemSettingsMutation,
} = settingApi;
